<template>
    <b-modal
        id="modal-planexternalbatches"
        size="xl"
        ref="modal"
        :title="this.formtitle"
        :visible="visible"
        @hidden="hide"
        @ok="handleOk"
    >
        <div class="form-inline">
            <period-selector
                id="selector-productionorder"
                style="width: 85%"
                v-model="selectDays"
                v-bind:periodDays="periodeDagen"
                v-bind:forceToday="true"
                @change="setNewDates"
            />
            <b-button @click="loadData()" class="bgc_aux_normal"
                ><font-awesome-icon icon="arrow-down" size="1x" />&nbsp;{{
                    $t('com_show', { ns: 'common' })
                }}
            </b-button>
        </div>
        <b-alert v-model="showDismissibleAlert" variant="danger" dismissible>
            {{ alertText }}
        </b-alert>

        <b-table
            striped
            responsive
            :fields="visibleFields"
            :items="displayList"
            stacked="md"
            small
            show-empty
            :empty-text="$t('com_geen_data', { ns: 'common' })"
        >
            <template v-slot:cell(actions)="row">
                <b-button
                    size="sm"
                    @click="handleAddItem(row.item)"
                    :disabled="isAddDisabled(row.item)"
                    class="bgc_aux_normal"
                    ><font-awesome-icon icon="folder-plus" size="1x" />
                </b-button>
                <b-button
                    v-if="row.item.variations"
                    size="sm"
                    @click="showVariations(row.item)"
                    class="bgc_aux_unimportant"
                    ><font-awesome-icon icon="info-circle" size="1x" />
                </b-button>
            </template>
        </b-table>
    </b-modal>
</template>

<script>
import _ from 'lodash';
import DateHelper from '../../models/DateHelper';
import Helper from '../../models/Helper';
import { loadItem } from '../../models/DataHelper';
import PeriodSelector from '../components/PeriodSelector.vue';

export default {
    name: 'PlanBatchesForm',
    data: function () {
        return {
            showDismissibleAlert: false,
            alertText: '',
            selectDays: null,
            periodeDagen: 1,
            isDagInfo: true,
            orderList: [],
            addItemDisabledUntil: {}
        };
    },
    components: {
        PeriodSelector
    },
    model: {
        prop: 'visible',
        event: 'hide'
    },
    props: {
        visible: {
            type: Boolean,
            default: false
        },
        lijst: {
            type: Array,
            default: () => []
        },
        refresh: {
            type: Number,
            default: 0
        }
    },
    watch: {
        refresh() {
            this.loadData();
        }
    },
    computed: {
        formtitle() {
            return this.$t('prod_prodorders', { ns: 'production' });
        },
        visibleFields() {
            const fieldsInit = [
                { key: 'actions', label: ' ', visible: true },
                { key: 'id', label: 'Id', sortable: false, visible: false },
                {
                    key: 'product',
                    label: this.$t('com_product', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'externID',
                    label: this.$t('com_externalid', { ns: 'common' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'ol_requesteddate', // key: 'productiedatum',
                    label: this.$t('prod_reqdate', { ns: 'production' }),
                    sortable: true,
                    visible: true,
                    formatter: this.displayDate
                },
                {
                    key: 'ol_requestedamount',
                    label: this.$t('prod_requested', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'toegewezen',
                    label: this.$t('prod_assigned', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'rest',
                    label: this.$t('prod_rest', { ns: 'production' }),
                    sortable: true,
                    visible: true
                },
                {
                    key: 'productions',
                    label: this.$t('prod_bakken', { ns: 'production' }),
                    sortable: true,
                    visible: true
                }
            ];
            return fieldsInit.filter((field) => field.visible);
        },
        displayList() {
            const lijst = this.orderList;
            return lijst;
        }
    },
    methods: {
        showAlert(tekst) {
            this.alertText = tekst;
            this.showDismissibleAlert = true;
        },
        displayDate(value) {
            return DateHelper.convertedToDate(value, false);
        },
        setNewDates(selDates) {
            const refreshData =
                this.van != selDates.van ||
                this.tot != selDates.tot ||
                this.dag != selDates.dag;
            this.van = selDates.van;
            this.tot = selDates.tot;
            this.dag = selDates.dag;
            this.isDagInfo = selDates.dag == 'day';
            if (refreshData) this.loadData();
        },
        async showVariations(item) {
            const lijst = await loadItem(
                'productionorder/loadOrderedAlternatives',
                { orderlineID: item.id },
                this.$t
            );
            let hinttekst = '';
            if (lijst.length > 0) {
                const klant =
                    this.$t('com_klant', { ns: 'common' }) +
                    ': ' +
                    lijst[0].customerName + ' (' + lijst[0].orderIDs + ')';
                hinttekst = Helper.concatString(hinttekst, klant);
                lijst.forEach((r) => {
                    const regel = Helper.stringformat(
                        '{0} ({1}): {2}',
                        r.productName,
                        r.shape,
                        r.orderedAmount
                    );
                    hinttekst = Helper.concatString(hinttekst, regel);
                });
            }
            alert(hinttekst);
        },
        async loadData() {
            const tot = this.isDagInfo
                ? DateHelper.localDateToUTC(DateHelper.addDays(this.van, 1))
                : DateHelper.localDateToUTC(this.tot);
            const van = DateHelper.localDateToUTC(this.van);
            const selectionData = {
                from: van,
                until: tot
            };
            this.orderList = await loadItem(
                'productionorder/loadProductionOrderInfo',
                selectionData,
                this.$t
            );
        },
        hide() {
            this.$emit('hide');
        },
        addItemKey(item) {
            if (item == null) return 'unknown';
            if (item.id != undefined && item.id != null) return String(item.id);
            if (item.externID != undefined && item.externID != null)
                return String(item.externID);
            if (item.product != undefined && item.product != null)
                return String(item.product);
            return 'unknown';
        },
        isAddDisabled(item) {
            const key = this.addItemKey(item);
            const disabledUntil = this.addItemDisabledUntil[key];
            return disabledUntil != undefined && disabledUntil > Date.now();
        },
        handleAddItem(item) {
            if (this.isAddDisabled(item)) return;

            const key = this.addItemKey(item);
            const disabledUntil = Date.now() + 3000;
            this.$set(this.addItemDisabledUntil, key, disabledUntil);
            this.addItem(item);

            setTimeout(() => {
                const currentDisabledUntil = this.addItemDisabledUntil[key];
                if (
                    currentDisabledUntil != undefined &&
                    currentDisabledUntil <= Date.now()
                ) {
                    this.$delete(this.addItemDisabledUntil, key);
                }
            }, 3000);
        },
        addItem(item) {
            this.$emit('addBatch', item);
        },
        checkFormValidity() {
            return true;
        },
        handleOk(bvModalEvt) {
            // Prevent modal from closing
            bvModalEvt.preventDefault();
            // Trigger submit handler
            this.handleSubmit();
        },
        handleSubmit() {
            // Exit when the form isn't valid
            if (!this.checkFormValidity()) {
                return;
            }
            // Hide the modal manually
            this.$nextTick(() => {
                this.$bvModal.hide('modal-planexternalbatches');
            });
        }
    },
    mounted() {},
    created() {
        this.orderList = this.lijst;
    }
};
</script>

<style scoped></style>
